import Vue from "vue";
import VueRouter, {RouteConfig} from "vue-router";
import Login from "@/views/login.vue";
import Home from "@/views/home.vue";
import ViewMaterial from "@/views/view-material.vue";
import ViewBrandManual from "@/views/view-brand-manual.vue";
import ManageUsers from "@/views/management/users.vue";
import ManageMaterials from "@/views/management/materials.vue";
import ManageMaterial from "@/views/management/material.vue";
import ManageBrandManuals from "@/views/management/brands.vue";
import TrainingCompletion from "@/views/training-completion.vue";
import PasswordReset from "@/views/password-reset.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: "/",
        name: "home",
        component: Home
    },
    {
        name: "authorize",
        path: "/authorize",
        component: Login
    },
    {
        name: "view-material",
        path: "/material/:id",
        component: ViewMaterial
    },
    {
        name: "brand-manual",
        path: "/brand-manual/:id",
        component: ViewBrandManual
    },
    {
        name: "manage-users",
        path: "/manage/users",
        component: ManageUsers
    },
    {
        name: "manage-materials",
        path: "/manage/materials",
        component: ManageMaterials,
    },
    {
        name: "add-material",
        path: "/manage/add-material",
        component: ManageMaterial,
    },
    {
        name: "edit-material",
        path: "/manage/edit-material/:id",
        component: ManageMaterial,
    },
    {
        name: "manage-brand-manuals",
        path: "/manage/brand-manuals",
        component: ManageBrandManuals,
    },
    {
        name: "report-training-completion",
        path: "/report/training-completion",
        component: TrainingCompletion,
    },
    {
        name: "password-reset",
        path: "/password-reset",
        component: PasswordReset,
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
